import React from 'react';

function Bold(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M13.75 2.375C16.166 2.375 18.125 4.33399 18.125 6.75C18.125 8.3133 17.3048 9.68525 16.0713 10.459L15.934 10.54L16.0923 10.6229C17.984 11.6453 19.2887 13.6147 19.3709 15.8959L19.375 16.125C19.375 19.5001 16.6998 22.2503 13.3541 22.3709L13.125 22.375H7.5H5C4.65482 22.375 4.375 22.0952 4.375 21.75C4.375 21.4362 4.60626 21.1764 4.90764 21.1318L5 21.125H6.875V10.5V3.625H5C4.65482 3.625 4.375 3.34518 4.375 3C4.375 2.6862 4.60626 2.42642 4.90764 2.38178L5 2.375H7.5H13.75ZM8.125 9.875V3.625H13.75L13.9273 3.62995C15.5705 3.72189 16.875 5.08385 16.875 6.75C16.875 8.47566 15.4757 9.875 13.75 9.875H13.125H8.125ZM8.125 11.125V21.125H13.125C15.8865 21.125 18.125 18.8865 18.125 16.125C18.125 13.3635 15.8865 11.125 13.125 11.125H8.125Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Bold;
